import modelBaseValidator from './customModel';

export default modelBaseValidator;
